import { z } from "zod";
import type { FactionId } from "./factions.js";

export const RELAY_PRESTIGE_ID = "relay-guardian";
export const RELAY_PRESTIGE_TITLE = "Страж рубежа";
export interface RelayCaptureRules {
  radius: number;
  captureSeconds: number;
  minimumPresenceSeconds: number;
  appearanceDelay: number;
  respawnDelay: number;
}
export interface RelayCaptureView {
  factionId: FactionId | null;
  contested: boolean;
  radius: number;
}
export interface PlayerPrestige {
  relayCaptures: number;
  title: typeof RELAY_PRESTIGE_TITLE | null;
}
export const RELAY_CAPTURE_RULES: RelayCaptureRules = {
  radius: 240,
  captureSeconds: 40,
  minimumPresenceSeconds: 8,
  appearanceDelay: 120,
  respawnDelay: 600,
};
export const relayCaptureRulesSchema: z.ZodType<RelayCaptureRules, RelayCaptureRules> = z
  .strictObject({
    radius: z.number().finite().positive().max(600),
    captureSeconds: z.number().finite().positive().max(600),
    minimumPresenceSeconds: z.number().finite().positive().max(600),
    appearanceDelay: z.number().finite().positive().max(86400),
    respawnDelay: z.number().finite().positive().max(86400),
  })
  .refine((rules) => rules.minimumPresenceSeconds <= rules.captureSeconds, {
    message: "Personal presence cannot exceed capture time",
  });
export const playerPrestigeSchema: z.ZodType<PlayerPrestige> = z
  .strictObject({
    relayCaptures: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
    title: z.literal(RELAY_PRESTIGE_TITLE).nullable(),
  })
  .refine(
    (prestige) => prestige.relayCaptures > 0 === (prestige.title !== null),
    {
      message: "Relay title requires a genuine victory",
    },
  );

export function playerPrestige(relayCaptures: number): PlayerPrestige {
  return playerPrestigeSchema.parse({
    relayCaptures,
    title: relayCaptures > 0 ? RELAY_PRESTIGE_TITLE : null,
  });
}
